import fb from '@/firebaseConfig';

async function createRandomAsset(owners, type) {
  if (type == AssetType.IMAGE) {
    const asset = new Asset({
      URL: 'https://placekitten.com/640/480',
      title: Math.random().toString(36).substring(2, 15),
      type: AssetType.IMAGE,
      owners: owners,
    });
    return asset;
  } else {
    return null;
  }
}

const AssetType = Object.freeze({
  IMAGE: 'image',
});

class Asset {
  constructor(parms) {
    this.DEBUGNOTE = 'wrapper class';
    this.id = parms.id || null;
    this.URL = parms.URL;
    this.title = parms.title;
    this.type = parms.type;
    this.owners = parms.owners;
  }

  fbDoc() {
    return {
      type: this.type,
      URL: this.URL,
      title: this.title,
      owners: this.owners,
    };
  }

  async fbSave() {
    if (!this.id) {
      return fb.db
        .collection('assets')
        .add(this.fbDoc())
        .then((docRef) => {
          this.id = docRef.id;
        });
    } else {
      fb.db
        .collection('assets')
        .doc(this.id)
        .set(this.fbDoc())
        .then(() => {
          return true;
        });
    }
  }
}

export default { Asset, AssetType, createRandomAsset };
